import { motion } from "framer-motion";
import { useEffect, useRef } from "react";

const Hero = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    // Ensure fetchpriority is set on the DOM element (React <19 may not forward it reliably)
    if (videoRef.current) {
      videoRef.current.setAttribute("fetchpriority", "high");
    }
  }, []);

  return (
    <section className="relative h-[75vh] w-full overflow-hidden">
      <div className="absolute inset-0">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster="/videos/hero-poster.jpg"
          className="h-full w-full object-cover"
        >
          <source src="/videos/hero.webm" type="video/webm" />
          <source src="/videos/hero.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-espresso/30" />
      </div>

      <div className="relative z-10 flex h-full flex-col items-center justify-end pb-24 text-center px-6">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="text-5xl md:text-7xl lg:text-8xl font-display font-light tracking-wide text-primary-foreground"
        >
          Love Otherwise
        </motion.h1>
        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.8, delay: 1 }}
          className="mt-6 h-px w-24 bg-champagne"
        />
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.3 }}
          className="mt-6 text-xs md:text-sm tracking-[0.3em] uppercase text-primary-foreground/85 font-body"
        >
          London · Ontario · Canada
        </motion.p>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10"
      >
        <div className="flex flex-col items-center gap-2">
          <span className="text-xs tracking-[0.3em] uppercase text-primary-foreground/70 font-body">Scroll</span>
          <div className="h-8 w-px bg-primary-foreground/40 animate-pulse" />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
